import { Typography } from 'antd';

interface MultilineParagraphProps {
  children?: string;
  emptyText?: string;
}

const MultilineParagraph = ({ children, emptyText = '-' }: MultilineParagraphProps) => {
  return (
    <>
      {children ? (
        children
          .split('\n')
          .map((paragraph, index) => (
            <Typography.Paragraph key={index}>{paragraph}</Typography.Paragraph>
          ))
      ) : (
        <Typography.Text>{emptyText}</Typography.Text>
      )}
    </>
  );
};

export default MultilineParagraph;
